import { GET_CAMPAIGN, GET_CAMPAIGN_START,GET_CAMPAIGN_DATA, GET_CAMPAIGN_END} from "./type";
import { validateToken, redirectToLogin } from '../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL


export const getAllCampaign = () => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  console.log('here its is')
  
  try {
    dispatch({
      type: GET_CAMPAIGN_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      console.log(token)
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/getAll/0/20`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: GET_CAMPAIGN_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: GET_CAMPAIGN_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_CAMPAIGN_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};




export const updateCampaignStatus = (campaignId: string, status: string): any => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    
    const response = await fetch(`${API_URL}/campaign/edit-status/${status}/${campaignId}`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const text = await response.text();
    const res = text ? JSON.parse(text) : {};

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_DATA, payload: res, loading: false });
      return { success: true, message: res.message || 'Operation successful', ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, message: res.message || 'Operation failed', ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};

export const cancelCampaign = (campaignId: string): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/edit-status/cancel/${campaignId}`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const text = await response.text();
    const res = text ? JSON.parse(text) : {};

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_DATA, payload: res, loading: false });
      return { success: true, message: res.message || 'Campaign cancelled successfully', ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, message: res.message || 'Failed to cancel campaign', ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};




export const archiveCampaign = (campaignId: string): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }

  try {
    dispatch({ type: GET_CAMPAIGN_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");

    const response = await fetch(`${API_URL}/campaign/edit-status/archive/${campaignId}`, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const text = await response.text();
    const res = text ? JSON.parse(text) : {};

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_DATA, payload: res, loading: false });
      return { success: true, message: res.message || 'Campaign archived successfully', ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_END, payload: res.message, loading: false });
      return { success: false, message: res.message || 'Failed to archive campaign', ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};
